// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/svg/dropdown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select {
  min-width: 138px !important;
  background-color: rgb(116, 184, 222);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  padding: 0px 14px;
  height: 25px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat, repeat;
  background-position: right 0.9em top 56%, 0 0;
  background-size: 0.7em auto, 100%;
}

.tses {
  margin-top: 6px;
  width: 100%;
}

.tses .item {
  margin-top: 6px;
  font-size: 13px;
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid rgb(221, 221, 221);
  display: flex;
  text-align: center;
  justify-content: space-between;
}

.tses .content {
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 10px;
  text-align: start;
  border-radius: 5px;
  background: rgb(156, 209, 242);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/views/admin/food/calendar/calendar.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EAIF,gBAAA;EACA,yDAAA;EACE,oCAAA;EACA,6CAAA;EACA,iCAAA;AAAJ;;AAGA;EACE,eAAA;EACA,WAAA;AAAF;;AAGA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;AAAF;;AAGA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;AAAF","sourcesContent":[".custom-select {\r\n    min-width: 138px !important;\r\n    background-color: rgba(116, 184, 222, 1);\r\n    border-radius: 8px;\r\n    color: white;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    padding: 0px 14px;\r\n    height: 25px;\r\n\r\n    -moz-appearance: none;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  background-image: url('../../../../assets/svg/dropdown.svg');\r\n    background-repeat: no-repeat, repeat;\r\n    background-position: right .9em top 56%, 0 0;\r\n    background-size: .7em auto, 100%;\r\n}\r\n\r\n.tses {\r\n  margin-top: 6px;\r\n  width: 100%;\r\n}\r\n\r\n.tses .item {\r\n  margin-top: 6px;\r\n  font-size: 13px;\r\n  padding: 5px 10px;\r\n  border-radius: 5px;\r\n  border: 1px solid rgba(221, 221, 221, 1);\r\n  display: flex;\r\n  text-align: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.tses .content {\r\n  text-transform: uppercase;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  padding: 5px 10px;\r\n  text-align: start;\r\n  border-radius: 5px;\r\n  background: rgba(156, 209, 242, 1);\r\n  color: white;\r\n}\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
